import React from "react";
import { CustomForm, CustomInput, CustomTextArea } from "../../shared/Input/AllInputs";
import ContactContainer from "./ContactContainer";

const ContactForm = ({ type }) => {
    const { data } = ContactContainer();
    return (
        <CustomForm style={type === "VIEW" ? { pointerEvents: "none" } : {}}>
            <CustomInput label="Full Name" name="fullName" data={data} />
            <CustomInput label="Email Address" name="email" data={data} disabled />
            <CustomInput label="Subject" name="subject" data={data} disabled />
            <CustomTextArea label="Message" name="message" data={data} disabled />
        </CustomForm>
    );
};

export default ContactForm;
